import type { SafePlaceDefinition } from '../../shared/game/rest-types.js';

// Core Rules p. 17: a Safe Rest needs a place the GM designates, such as an inn, cabin or shrine; camping in the open is not enough.
export const emberCoastSafePlaces: SafePlaceDefinition[] = [
  { id: 'crossroads-camp', name: 'Crossroads camp', x: 28, z: -14, radius: 10 },
  { id: 'keepers-house', name: 'Keeper’s house', x: -204, z: 186, radius: 10 },
  { id: 'chapel-sanctuary', name: 'Chapel sanctuary', x: -102, z: -322, radius: 10 },
  { id: 'wrack-cove-lodging', name: 'Wrack Cove lodging', x: -300, z: -132, radius: 10 },
];
